"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _Heartbeat = require("./Heartbeat.styles");

var _svgElements = require("../../components/svg-elements");

var _pulse = _interopRequireDefault(require("../../components/pulse"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Heartbeat = function Heartbeat(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      disableHover = _ref.disableHover,
      name = _ref.name;
  var heartbeatConfig = config || _hotspot.heartbeat;
  var primaryColor = heartbeatConfig.primaryColor,
      secondaryColor = heartbeatConfig.secondaryColor;
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_Heartbeat.ClickableAreaStyled, {
    onClick: onClick,
    primaryColor: primaryColor,
    previewHoverState: previewHoverState,
    secondaryColor: secondaryColor,
    disableHover: disableHover,
    "aria-label": ariaLabel
  }, iconPosition && _react.default.createElement(_Heartbeat.HeartbeatStyled, {
    config: heartbeatConfig,
    iconPosition: iconPosition
  }, _react.default.createElement(_pulse.default, {
    className: "pulse",
    animation: "700ms infinite 200ms",
    size: "100%",
    shadow: primaryColor,
    customStartState: "opacity: 1;",
    customMiddleState: "opacity: 1;",
    customEndState: "opacity: 0;"
  }), _react.default.createElement(_Heartbeat.CenterCircle, {
    background: primaryColor,
    className: "center-circle"
  }, _react.default.createElement(_svgElements.Svg, {
    viewBox: "0 0 74 74",
    preserveAspectRatio: "xMinYMin"
  }, _react.default.createElement(_svgElements.Path, {
    strokeWidth: "8",
    stroke: secondaryColor,
    fill: secondaryColor,
    strokeOpacity: "1",
    d: "M 74,33 74,41 41,41 41,74 33,74 33,41 0,41 0,33 33,33 33,0 41,0 41,33 z"
  })))));
};

var _default = Heartbeat;
exports.default = _default;